import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

/*
 ** @description Prepare data for api
 ** @param props Object reference_number, travel_type, user
 ** @return data object
 */
const handlePrepareData = ({
  reference_number, travel_type, user
}) => ({
  reference_number,
  user_id: user.key,
  travel_type
});

const Itineraries = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminTravel()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.travelItinerary,
      list: REDUCER_KEY.travelItineraries
    }}
    config={config}
    onPrepareData={handlePrepareData}
    permissions={permissions}
    messaging={{
      delete: {
        disabled: () => 'Item Disabled.',
        failure: error => `Delete Failed. ${error}`,
        success: () => 'Delete Successful.'
      },
      save: {
        failure: data => `Saving itinerary ${data.reference_number} failed`,
        success: data => `Saving itinerary ${data.reference_number} was successful`
      }
    }}
  />
);

Itineraries.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default Itineraries;
